<template>
    <div class="DshSwitch" :style="{ textAlign: propsObj._textAlign }">
        <!-- 组件无clearable -->
        <i-switch
            v-model="value[propsObj._key]"
            :size="propsObj._size"
            :disabled="!finalCanEdit"
            @on-change="change"
        >
            <span slot="open" style="font-size: 12px;">{{ propsObj._openText }}</span>
            <span slot="close">{{ propsObj._closeText }}</span>
        </i-switch>
        <!-- <i-switch
            v-else
            :size="small"
            :disabled="true"
            :value="value[propsObj._key]"
            style="text-align:center"
        >
        </i-switch> -->
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshSwitch",
        mixins: [controlMixin],
        data () {
            return {};
        },
        computed: {},
        created () {
        },
        methods: {}
    };
</script>

<style lang="less" scoped>
    .DshSwitch {

    }
</style>
<style lang="less">
    .DshSwitch {
        .ivu-switch {
            width: 50px;
        }
        .ivu-switch-checked:after {
            left: 29px;
        }
        .ivu-switch-inner {
            color: #fff;
            font-size: 12px;
            position: absolute;
            left: auto;
            right: 4px;
        }
        .ivu-switch-checked .ivu-switch-inner {
            left: 3px;
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshSwitch.vue